import { IAppState } from "./state";

export interface IAppGetters {
  loading(state: IAppState): boolean;
}

export const AppGetters: IAppGetters = {
  loading(state: IAppState): boolean {
    return state.loading;
  },
};
